import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { getBidTitleDetails } from '@bingads-webui-campaign-react/wizard-shared-components';

const formatBidStrategy = (i18n, data) => getBidTitleDetails(i18n, data);


export const BidStrategy = ({ data }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Bid strategy') }}>
      <Text>{formatBidStrategy(i18n, data)}</Text>
    </PropertyRow>
  );
};

BidStrategy.propTypes = {
  data: PropTypes.shape({}),
};

BidStrategy.defaultProps = {
  data: {},
};
